import * as constants from '@/utils/analytics/constants/constants'

export const BROWSE_PORTFOLIO_PAGE = `${ constants.BROWSE_PORTFOLIO }_opened`
export const BROWSE_PORTFOLIO_GREEN_WORLD_ACCESS = `${ constants.BROWSE_PORTFOLIO }_green_world_access`
export const BROWSE_PORTFOLIO_YELLOW_WORLD_ACCESS = `${ constants.BROWSE_PORTFOLIO }_yellow_world_access`
